import cssVariables from 'tfs.css-variables'

export default {
  button: {
    float: 'right',
  },
  icon: {
    fontSize: '1.3rem',
    position: 'absolute',
    right: 0,
    bottom: '7px',
  },
  seatType: {
    '&::after': {
      content: '" / "',
      marginLeft: '.2rem',
      position: 'absolute',
    },
    '&:last-child::after': {
      content: '""',
    },
  },
  row: {
    display: 'flex',
    borderBottom: `1px solid ${cssVariables.colorGrayE}`,

    '&:last-child': {
      borderBottom: 'none',
    },
  },
  cel: {
    display: 'inline-flex',
    flexBasis: '10rem',
    padding: '1.5rem 0',
    fontSize: '1.5rem',
    alignSelf: 'center',

    '&> *': {
      marginRight: '1rem',
    },

    '&> *:last-child': {
      marginRight: '0rem',
    },
  },
  lastCel: {
    marginLeft: 'auto',
  },
}
